import {
  ActiveInactiveStatus,
  ApiListResponse,
  SessionPackDTO,
} from "@gymflow/types";

import { createAxiosInstance } from "../createAxiosInstance";

export type PublicCreditPackApiType = ReturnType<typeof publicCreditPack>;

const publicCreditPack = (apiUrl: string, clubId: number) => {
  const clubPrefix = `club/${clubId}/`;
  const axiosInstance = createAxiosInstance({
    apiUrl,
  });

  return {
    getById(id: number) {
      return axiosInstance.get<SessionPackDTO>(
        `${clubPrefix}hosted/sessionpack/${id}`,
      );
    },
    getList(params: {
      status?: ActiveInactiveStatus;
      id?: number[];
      hasActivityCategory?: boolean;
      hasAppointableCategory?: boolean;
      page: number;
      size: number;
      sort?: string;
    }) {
      return axiosInstance.get<ApiListResponse<SessionPackDTO>>(
        `${clubPrefix}hosted/sessionpack`,
        {
          params,
        },
      );
    },
  };
};

export default publicCreditPack;
